export const AI_TOOLKIT_ERROR_CODES = {
  UnknownTool: "ai_toolkit_unknown_tool",
  InvalidInput: "ai_toolkit_invalid_input",
  NoteNotFound: "ai_toolkit_note_not_found",
  NoteContentNotFound: "ai_toolkit_note_content_not_found",
  AssistantTaskNotFound: "ai_toolkit_assistant_task_not_found",
  AssistantProjectNotFound: "ai_toolkit_assistant_project_not_found",
  AssistantFollowUpNotFound: "ai_toolkit_assistant_follow_up_not_found",
  AssistantNotFound: "ai_toolkit_assistant_not_found",
  CalendarEventNotFound: "ai_toolkit_calendar_event_not_found",
  CollectionNotFound: "ai_toolkit_collection_not_found",
  ExecutionFailed: "ai_toolkit_execution_failed",
} as const;

export type AiToolkitErrorCode =
  (typeof AI_TOOLKIT_ERROR_CODES)[keyof typeof AI_TOOLKIT_ERROR_CODES];

export type AiToolkitSerializedError = {
  code: AiToolkitErrorCode;
  message: string;
  name: string;
  info?: Record<string, unknown>;
};
